<template>
  <div class="modal-vue modal-add-items fade-in confirm-modal" v-if="isVisible">
    <span class="container-icon" title="Закрыть" @click="closeModal()">
      <mdicon name="close" width="22" height="22"/> 
    </span>
    <div>
      <p v-html="message"></p>
      <button 
        class="btn btn-default"
        type="submit"
        @click="confirm()"
      >
        ОК
      </button>
    </div>
  </div>
  <div v-if="isVisible" class="overlay"></div>
</template>
  <script>
  export default {
    name: 'ConfirmModal',
    data() {
      return {
        isVisible: false,
        onConfirm: null,
        message: "",
      }
    },
    methods: {
      open(confirmCallback, message = 'Подтвердите действия') {
        this.isVisible = true;
        this.onConfirm = confirmCallback;
        this.message = message;
      },

      confirm() {
        if (this.onConfirm) {
          this.onConfirm();
        }
        this.hide();
      },

      closeModal() {
        this.hide();
      },

      hide() {
        this.isVisible = false;
      },
    }
  };
  </script>